<template>
  <div class="main">
    <el-row>
      <!-- 查询条件 -->
      <el-col class="pagin" ref="query">
        <el-row class="mb5 mt2 ml2">
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">流水号:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.seq" size="small" placeholder="流水号" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">用户工厂:</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.userFactId" filterable placeholder="请选择用户工厂" clearable size="small" class="full" @clear="onSelectClear('userFactIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userFactId', 'userFactIdCacheList')">
                  <el-option v-for="(item, index) in userFactIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">用户仓库:</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.userStoreId" filterable placeholder="请选择用户仓库" clearable size="small" class="full" @clear="onSelectClear('userStoreIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userStoreId', 'userStoreIdCacheList')">
                  <el-option v-for="(item, index) in userStoreIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">终端设备:</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.userSubId" filterable placeholder="请选择终端设备" clearable size="small" class="full" @clear="onSelectClear('userSubIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userSubId', 'userSubIdCacheList')">
                  <el-option v-for="(item, index) in userSubIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">创建时间:</div>
            <div class="pl4-6 width-200">
              <el-date-picker
                style="width: 205px;"
                :clearable="true"
                v-model="createTimeDate"
                :picker-options="disabledAfterNow"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="inline-block mr4">
            <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
          </div>
          <!-- 导出操作 -->
          <el-dropdown v-if="checkPermission(funcData, 'export')" class="mr4" size="small" type="primary" trigger="click">
            <el-button type="primary" size="small">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="px10" @click.native="onExport('excel')">excel</el-dropdown-item>
              <el-dropdown-item class="px10" @click.native="onExport('csv')">csv</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
        </el-row>
      </el-col>

      <!-- 表格  -->
      <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
      <el-col v-else>
        <el-table
          ref="table"
          :key="Math.random()"
          v-loading="pageLoading"
          element-loading-text="拼命加载中"
          size="mini"
          stripe
          border
          style="width: 100%"
          :height="pageHeight"
          :data="dataList"
          :header-cell-class-name="onHeaderClass"
          @sort-change="onSortChange"
          ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

          <el-table-column align="center" label="序号" type="index"></el-table-column>

          <el-table-column width="52px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="seq"
            label="流水号"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="merDevId"
            label="商户设备"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.merDevId|dict(merDevIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="merSubId"
            label="商户子设备"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.merSubId|dict(merSubIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userDevId"
            label="主设备"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.userDevId|dict(userDevIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userSubId"
            label="终端设备"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.userSubId|dict(userSubIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="value1"
            label="温度"
            sortable="custom"
            >
            <template slot-scope="scope">{{scope.row.value1|append('℃')}}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="value2"
            :label="userInfo.userHumName"
            sortable="custom"
            >
            <template slot-scope="scope">{{scope.row.value2|append(userInfo.userHumUnit)}}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="startSeq"
            label="开始流水号"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endSeq"
            label="结束流水号"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="startTime"
            label="开始时间"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            label="结束时间"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="duration"
            label="持续时长(秒)"
            sortable="custom"
            >
          </el-table-column>
        </el-table>
      </el-col>

      <!-- 分页 -->
      <el-col class="pagination">
        <el-pagination
          background
          :current-page="pageParam.pageNo"
          :page-sizes="[30, 50, 100, 200, 500, 1000]"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          layout="prev, pager, next, total, jumper, sizes"
          :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="1000px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 报警记录详情</template>
      <el-descriptions class="detail-div" :column="3" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>流水号</template>
          {{dataDetail.seq}}
        </el-descriptions-item>
        <!-- <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>网关</template>
          {{dataDetail.produerGwId|dict(produerGwIdCacheListCopy)}}
          >
          {{dataDetail.gwId|dict(gwIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>设备</template>
          {{dataDetail.produerDevId|dict(produerDevIdCacheListCopy)}}
          >
          {{dataDetail.devId|dict(devIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>终端设备</template>
          {{dataDetail.produerSubId|dict(produerSubIdCacheListCopy)}}
          >
          {{dataDetail.subId|dict(subIdCacheListCopy)}}
        </el-descriptions-item> -->
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>商户子设备</template>
          {{dataDetail.merId|dict(merIdCacheListCopy)}}
          >
          {{dataDetail.merGwId|dict(merGwIdCacheListCopy)}}
          >
          {{dataDetail.merDevId|dict(merDevIdCacheListCopy)}}
          >
          {{dataDetail.merSubId|dict(merSubIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-user-solid"></i>终端设备</template>
          {{dataDetail.userFactId|dict(userFactIdCacheListCopy)}}
          >
          {{dataDetail.userStoreId|dict(userStoreIdCacheListCopy)}}
          >
          {{dataDetail.userPointId|dict(userPointIdCacheListCopy)}}
          >
          {{dataDetail.userGwId|dict(userGwIdCacheListCopy)}}
          >
          {{dataDetail.userDevId|dict(userDevIdCacheListCopy)}}
          >
          {{dataDetail.userSubId|dict(userSubIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>温度</template>
          {{dataDetail.value1|append('℃')}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>报警最小温度</template>
          {{dataDetail.alertMin1|append('℃')}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>报警最大温度</template>
          {{dataDetail.alertMax1|append('℃')}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>{{userInfo.userHumName}}</template>
          {{dataDetail.value2|append(userInfo.userHumUnit)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>报警最小{{userInfo.userHumName}}</template>
          {{dataDetail.alertMin2|append(userInfo.userHumUnit)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>报警最大{{userInfo.userHumName}}</template>
          {{dataDetail.alertMax2|append(userInfo.userHumUnit)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>开始流水号</template>
          {{dataDetail.startSeq}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>结束流水号</template>
          {{dataDetail.endSeq}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>开始时间</template>
          {{dataDetail.startTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>结束时间</template>
          {{dataDetail.endTime}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-time"></i>持续时长(秒)</template>
          {{dataDetail.duration}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>维护原因</template>
          {{dataDetail.maintenancetReason}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>维护结果</template>
          {{dataDetail.maintenanceResult}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user-solid"></i>维护人</template>
          {{dataDetail.maintenanceOperator}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>维护时间</template>
          {{dataDetail.maintenanceTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'userplatJourJouralert',
  data () {
    return {
      menuName: 'userplatJourJouralert',
      formQuery: { // 查询对象
        seq: '', // 流水号
        userFactId: '', // 用户工厂
        userStoreId: '', // 用户仓库
        userSubId: '', // 终端设备
        createTimeBegin: '', // 创建时间-开始时间
        createTimeEnd: '' // 创建时间-结束时间
      },
      produerGwIdCacheList: [],
      produerGwIdCacheListCopy: [],
      gwIdCacheList: [],
      gwIdCacheListCopy: [],
      produerDevIdCacheList: [],
      produerDevIdCacheListCopy: [],
      devIdCacheList: [],
      devIdCacheListCopy: [],
      produerSubIdCacheList: [],
      produerSubIdCacheListCopy: [],
      subIdCacheList: [],
      subIdCacheListCopy: [],
      merIdCacheList: [],
      merIdCacheListCopy: [],
      merGwIdCacheList: [],
      merGwIdCacheListCopy: [],
      merDevIdCacheList: [],
      merDevIdCacheListCopy: [],
      merSubIdCacheList: [],
      merSubIdCacheListCopy: [],
      userFactIdCacheList: [],
      userFactIdCacheListCopy: [],
      userStoreIdCacheList: [],
      userStoreIdCacheListCopy: [],
      userPointIdCacheList: [],
      userPointIdCacheListCopy: [],
      userGwIdCacheList: [],
      userGwIdCacheListCopy: [],
      userDevIdCacheList: [],
      userDevIdCacheListCopy: [],
      userSubIdCacheList: [],
      userSubIdCacheListCopy: [],
      idName: 'seq',
      httpUrl: '/jour/jourAlert',
      httpUri: {
        produerGwIdCacheUri: '/cache/devProd',
        gwIdCacheUri: '/cache/devGw',
        produerDevIdCacheUri: '/cache/devProd',
        devIdCacheUri: '/cache/devDev',
        produerSubIdCacheUri: '/cache/devProd',
        subIdCacheUri: '/cache/devDev',
        merIdCacheUri: '/cache/merInfo',
        merGwIdCacheUri: '/cache/merGw',
        merDevIdCacheUri: '/cache/merDev',
        merSubIdCacheUri: '/cache/merSub',
        userFactIdCacheUri: '/cache/userFactory',
        userStoreIdCacheUri: '/cache/userStore',
        userPointIdCacheUri: '/cache/userPoint',
        userGwIdCacheUri: '/cache/userGw',
        userDevIdCacheUri: '/cache/userDev',
        userSubIdCacheUri: '/cache/userSub'
      }
    }
  },
  watch: {
    'formQuery.userFactId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userFactIdCacheList', 'userStoreIdCacheList', this.httpUri.userStoreIdCacheUri, this.formQuery, 'userStoreId', true, { userFactId: curVal })
      }
    },
    'formQuery.userStoreId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userStoreIdCacheList', 'userSubIdCacheList', this.httpUri.userSubIdCacheUri, this.formQuery, 'userSubId', true, { userStoreId: curVal })
      }
    }
  },
  mounted () {
    this.httpSelectList('produerGwIdCacheList', this.httpUri.produerGwIdCacheUri)
    this.httpSelectList('gwIdCacheList', this.httpUri.gwIdCacheUri)
    this.httpSelectList('produerDevIdCacheList', this.httpUri.produerDevIdCacheUri)
    this.httpSelectList('devIdCacheList', this.httpUri.devIdCacheUri)
    this.httpSelectList('produerSubIdCacheList', this.httpUri.produerSubIdCacheUri)
    this.httpSelectList('subIdCacheList', this.httpUri.subIdCacheUri)
    this.httpSelectList('merIdCacheList', this.httpUri.merIdCacheUri)
    this.httpSelectList('merGwIdCacheList', this.httpUri.merGwIdCacheUri)
    this.httpSelectList('merDevIdCacheList', this.httpUri.merDevIdCacheUri)
    this.httpSelectList('merSubIdCacheList', this.httpUri.merSubIdCacheUri)
    this.httpSelectList('userFactIdCacheList', this.httpUri.userFactIdCacheUri)
    this.httpSelectList('userStoreIdCacheList', this.httpUri.userStoreIdCacheUri)
    this.httpSelectList('userPointIdCacheList', this.httpUri.userPointIdCacheUri)
    this.httpSelectList('userGwIdCacheList', this.httpUri.userGwIdCacheUri)
    this.httpSelectList('userDevIdCacheList', this.httpUri.userDevIdCacheUri)
    this.httpSelectList('userSubIdCacheList', this.httpUri.userSubIdCacheUri)
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

</style>
